import React from 'react';
import { Button } from 'rsuite';
import { ContentContainer, LoadingSpinerLocal } from '../../../../../components';
import { BigNumbersBox } from '../../../../../components/BigNumbersBox';
import styles from './BigNumbersArea.module.scss';
import { BigNumbersPriceBox } from '../BigNumbersPriceBox';

type BigNumbersAreaProps = {
  data: any;
  update?: boolean;
  loading?: boolean;
  onClickUpdate?: () => void;
};

const estimativa = (value: number) => {
  if (value > 0) {
    return 'up';
  }
  if (value < 0) {
    return 'down';
  }
  return 'container';
};

export const BigNumbersArea = ({ data, update, loading, onClickUpdate }: BigNumbersAreaProps) => {
  return (
    <ContentContainer className={styles.content}>
      <BigNumbersBox.Root height="73px" className={styles['total-products-box']}>
        <LoadingSpinerLocal size="sm" position="absolute" loading={loading} />
        <div className={styles['flex-center']}>
          <BigNumbersBox.MainValue>{data?.totalProdutos}</BigNumbersBox.MainValue>
        </div>
        <div>
          <BigNumbersBox.RegularText>total de</BigNumbersBox.RegularText>
          <BigNumbersBox.RegularText>produtos</BigNumbersBox.RegularText>
        </div>
      </BigNumbersBox.Root>
      <BigNumbersPriceBox
        type="currency"
        loading={loading}
        mainValue={data?.faturamentoProjetado?.valorProjetado || 0}
        indicator={data?.faturamentoProjetado?.variacaoPercentual || 0}
        firstText="Faturamento projetado,"
        secondText="era "
        secondValue={data?.faturamentoProjetado?.valorAnterior || 0}
      />
      <BigNumbersPriceBox
        type="currency"
        loading={loading}
        mainValue={data?.lucroBrutoProjetado?.valorProjetado || 0}
        indicator={data?.lucroBrutoProjetado?.variacaoPercentual || 0}
        firstText="Lucro bruto"
        secondText="projetado, era "
        secondValue={data?.lucroBrutoProjetado?.valorAnterior || 0}
      />
      <BigNumbersPriceBox
        type="percent"
        loading={loading}
        mainValue={data?.margemBrutaProjetada?.valorProjetado || 0}
        indicator={data?.margemBrutaProjetada?.variacaoPercentual || 0}
        firstText="Margem bruta"
        secondText="projetada, era "
        secondValue={data?.margemBrutaProjetada?.valorAnterior || 0}
      />
      <BigNumbersPriceBox
        type="currency"
        loading={loading}
        mainValue={data?.lucroOperacionalProjetado?.valorProjetado || 0}
        indicator={data?.lucroOperacionalProjetado?.variacaoPercentual || 0}
        firstText="Lucro operacional"
        secondText="projetado, era "
        secondValue={data?.lucroOperacionalProjetado?.valorAnterior || 0}
      />
      <BigNumbersPriceBox
        type="percent"
        loading={loading}
        mainValue={data?.margemOperacionalProjetada?.valorProjetado || 0}
        indicator={data?.margemOperacionalProjetada?.variacaoPercentual || 0}
        firstText="Margem operacional"
        secondText="projetada, era "
        secondValue={data?.margemOperacionalProjetada?.valorAnterior || 0}
      />
      <BigNumbersPriceBox
        type="currency"
        loading={loading}
        styleType={estimativa(data?.estimativaLucro?.variacaoPercentual)}
        mainValue={data?.estimativaLucro?.valorProjetado || 0}
        indicator={data?.estimativaLucro?.variacaoPercentual || 0}
        firstText="Estimativa de"
        secondText="diferença no lucro "
      />

      {update ? (
        <Button appearance="default" className={styles['update-button']} onClick={onClickUpdate}>
          <BigNumbersBox.RegularText>Cálculos</BigNumbersBox.RegularText>
          <BigNumbersBox.RegularText>desatualizados</BigNumbersBox.RegularText>
          <p className={styles['blue-text']}>Atualizar</p>
        </Button>
      ) : null}
    </ContentContainer>
  );
};
